const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    one: {
        id: 'one',
        type: REFERENCE_ASSETS.ONE,
        symbol: 'ONE',
        decimals: 1e18,
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    },
    wone: {
        id: 'wone',
        type: REFERENCE_ASSETS.ONE,
        symbol: 'WONE',
        decimals: 1e18,
        address: '0xcf664087a5bb0237a0bad6742852ec6c8d69a27a',
        coingeckoId: 'wrapped-one',
    },
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'usd-coin',
        symbol: 'DAI',
        decimals: 1e18,
        address: '0xEf977d2f931C1978Db5F6747666fa1eACB0d0339',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'usd-coin',
        symbol: 'USDC',
        decimals: 1e6,
        address: '0x985458E523dB3d53125813eD68c274899e9DfAb4',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'usd-coin',
        symbol: 'USDT',
        decimals: 1e6,
        address: '0x3c2b8be99c50593081eaa2a724f0b8285f5aba8f',
    },
    wbtc: {
        id: 'wbtc',
        coingeckoId: 'bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'wBTC',
        decimals: 1e8,
        address: '0x3095c7557bcb296ccc6e363de01b760ba031f2d9',
    },
    weth: {
        id: 'weth',
        coingeckoId: 'ethereum',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'WETH',
        decimals: 1e18,
        address: '0x6983d1e6def3690c4d616b13597a09e6193ea013',
    }
};
